export enum CurrentClientFavoriteApiTags {
  FavoriteClientsList = 'CurrentClientFavoriteClientsList',
}

export const currentClientApiTagTypes = Object.values(CurrentClientFavoriteApiTags);
